


















import { Component, Prop, Vue } from 'vue-property-decorator';
import Arrow from '@/components/icons/Arrow.vue';

@Component({
  components: {
    Arrow
  }
})
export default class BusinessBox extends Vue {
  @Prop({ default: '' }) private title!: string;
  @Prop({ default: '' }) private subtitle!: string;
  @Prop() private logo!: string;
  @Prop({ default: false }) private disabled!: boolean;
}
